import { useMemo } from 'react'

import { QueryKeys } from '../../../constants/queryKeys.constants'
import { FirebaseCollections } from '../../../constants/firebase.constants'
import { useFirestoreQuery } from '../../../hooks/useFirestore'
import { orderByBookingDate, whereBookingDateFrom, whereBookingStatus } from '../../../services/firestore.service'
import { CompletedBookingFirestoreData } from '../../../types/booking.types'
import { StripeStatus } from '../../Payments/components/PaymentForm/model/model'
import { startOfTodayInAppTimezone } from '../../../utils/dateTime.utils'

const CONFIG_WARNINGS_STALE_TIME_MS = 5 * 60 * 1000

export const useFutureSucceededBookingsForWarnings = (enabled: boolean) => {
  const today = startOfTodayInAppTimezone()
  const todayKey = today.format('YYYY-MM-DD')

  const { data, isLoading } = useFirestoreQuery<CompletedBookingFirestoreData>(
    [QueryKeys.COMPLETED_BOOKINGS, 'configWarnings', todayKey],
    FirebaseCollections.COMPLETED_BOOKINGS,
    [whereBookingStatus(StripeStatus.SUCCEEDED), whereBookingDateFrom(today), orderByBookingDate('asc')],
    undefined,
    { enabled, staleTime: CONFIG_WARNINGS_STALE_TIME_MS }
  )

  return useMemo(
    () => ({
      bookings: data ?? [],
      isLoading,
    }),
    [data, isLoading]
  )
}
